import { render, staticRenderFns } from "./ContractCarousel.vue?vue&type=template&id=55f8841b&scoped=true"
import script from "./ContractCarousel.vue?vue&type=script&lang=js"
export * from "./ContractCarousel.vue?vue&type=script&lang=js"
import style0 from "./ContractCarousel.vue?vue&type=style&index=0&id=55f8841b&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f8841b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55f8841b')) {
      api.createRecord('55f8841b', component.options)
    } else {
      api.reload('55f8841b', component.options)
    }
    module.hot.accept("./ContractCarousel.vue?vue&type=template&id=55f8841b&scoped=true", function () {
      api.rerender('55f8841b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/employeeKanban/components/ContractCarousel.vue"
export default component.exports